/**
 * @file edit-sub-categories.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/category/edit-sub-categories.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/category/edit-sub-categories
 * @description Edit sub-category page for uProcure master categories module.
 *   Reuses the same form and logic as the AddSubCategory page, but with
 *   pre-filled values and an API call to update instead of create. Accessed
 *   via the "Edit" action button on the sub-category rows in the main
 *   categories list page.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Missing auditLogMessage in categoryJSON.editSubCategory API payload — see uprocure-admin
 *   edit-sub-categories.tsx (generateLogMessageForCategory + warehouseName).
 * @todo Missing useDebounce(fetchPrimaryCategory, 500) for primary-category dropdown search — uprocure-admin has it.
 */

import React, { FC, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomSelect } from "../../../../custom/Select/CustomSelect";
import UploadImage from "../.../../../../../../_admin/assets/media/svg_uTrade/add-img.svg";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import { categoryJSON } from "../../../../../api/apiJSON/master";
import { Categories, PAGE_LIMIT } from "../../../../../utils/constants";
import Close from "../../../../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg";
import { masterToast } from "../../../../../utils/toast";
import { success } from "../../../../../Global/toast";
// import { warehouse as warehouseStoreString } from '../../../../utils/storeString';
// import { getKey } from '../../../../Global/history';
import { useAuth } from "../../../auth";
import Method from "../../../../../utils/methods";
import { useWarehouse } from "../../../../context/WarehouseContext";

const EditSubCategories: FC = () => {
  const { currentUser } = useAuth();
  const { selectedWarehouse } = useWarehouse();
  const depth = 1;
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const [primaryCategory, setPrimaryCategory] = useState<any>([]);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [subCategory, setSubCategory] = useState<{
    subCategoryName: string;
    subCategoryImage: any;
    subCategoryImageReader: any;
    primaryCategory: string;
    defaultCategory: any;
  }>({
    subCategoryName: state.title,
    subCategoryImage: state.image,
    subCategoryImageReader: state.image,
    primaryCategory: state.primaryCategories._id,
    defaultCategory: {
      label: (
        <>
          <span className="symbol symbol-xl-40px symbol-35px border border-r10px me-2">
            <img src={state.primaryCategories.image} className="p-1" alt="" />
          </span>
          <span className="fs-16 fw-600 text-black ">
            {state.primaryCategories.title}
          </span>
        </>
      ),
      value: state.primaryCategories.title,
      title: state.primaryCategories.title,
      _id: state.primaryCategories._id,
    },
  });
  const [initialSubCategory, setInitialSubCategory] = useState<any>({
    subCategoryName: state.title,
    subCategoryImage: state.image,
    primaryCategory: state.primaryCategories._id,
  });
  const [validation, setValidation] = useState<{
    subCategoryName: boolean;
    subCategoryImage: boolean;
    primaryCategory: boolean;
  }>({
    subCategoryName: false,
    subCategoryImage: false,
    primaryCategory: false,
  });
  useEffect(() => {
    (async () => {
      setFetchLoader(true);
      await fetchPrimaryCategory(page, PAGE_LIMIT, depth);
      setFetchLoader(false);
    })();
  }, []);
  const fetchPrimaryCategory = async (
    pageNo: number,
    limit: number,
    categoriesDepth: number,
    search: string = "",
  ) => {
    setFetchLoader(true);
    let params: any = {
      pageNo: pageNo,
      limit: limit,
      searchTerm: search,
      needCount: true,
      categoriesDepth: categoriesDepth,
    };
    if (selectedWarehouse?.value) {
      params = {
        ...params,
        warehouse: selectedWarehouse?.value,
      };
    }
    let apiService = new APICallService(
      master.categoryList,
      params,
      "",
      "",
      "",
      "",
      Categories,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    // let data: any = [...primaryCategory];
    // if (pageNo === 1) {
    //   setTotalRecords(response.total);
    // } else {
    //   let prevTotal = totalRecords;
    //   setTotalRecords(prevTotal);
    // }
    if (response.records) {
      setTotalRecords(response.total);
      let data: any = (prevResults: any) =>
        pageNo === 1 ? response.records : [...prevResults, ...response.records];
      setPrimaryCategory(data);
    }
    setFetchLoader(false);
    // response.records.map((val: any) => {
    //   return data.push({
    //     value: val.title,
    //     name: val.title,
    //     label: (
    //       <>
    //         <span className="symbol symbol-xl-40px symbol-35px border border-r10px me-2">
    //           <img
    //             src={val.image}
    //             className="p-1"
    //             alt=""
    //           />
    //         </span>
    //         <span className="fs-16 fw-600 text-black ">{val.title}</span>
    //       </>
    //     ),
    //     title: val.title,
    //     _id: val._id,
    //   });
    //});
  };
  const onMenuScrollToBottom = async () => {
    if (!(primaryCategory.length === totalRecords)) {
      let tempPage = page;
      tempPage = tempPage + 1;
      setPage(tempPage);
      await fetchPrimaryCategory(tempPage, PAGE_LIMIT, depth);
    }
  };
  const onMenuClose = async () => {
    setSearchTerm("");
  };
  const onMenuOpen = async () => {
    setPage(1);
    await fetchPrimaryCategory(1, PAGE_LIMIT, depth, searchTerm);
  };
  const handleInputChange = async (newValue: string) => {
    setPage(1);
    setSearchTerm(newValue);
    await fetchPrimaryCategory(1, 0, depth, newValue);
  };
  const handleImageDiscard = () => {
    let temp = { ...subCategory };
    let validateTemp = { ...validation };
    validateTemp.subCategoryImage = true;
    temp.subCategoryImage = "";
    temp.subCategoryImageReader = {};
    setSubCategory(temp);
    setValidation(validateTemp);
  };
  const handleRemove = async (e: any, index: any) => {
    let temp = { ...subCategory };
    // temp.splice(0, 1)
    setSubCategory(temp);
  };
  const handleSubCategoryName = (value: any, index: any) => {
    let temp = { ...subCategory };
    let validateTemp = { ...validation };
    temp.subCategoryName = value.trimStart();
    if (value.trimStart().length > 0) {
      validateTemp.subCategoryName = false;
    } else {
      validateTemp.subCategoryName = true;
    }
    setSubCategory(temp);
    setValidation(validateTemp);
  };
  const handlePrimaryCategoryChange = (event: any, index: any) => {
    let temp = { ...subCategory };
    let validateTemp = { ...validation };
    temp.primaryCategory = event._id;
    validateTemp.primaryCategory = false;
    setSubCategory(temp);
    setValidation(validateTemp);
  };
  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: any,
  ) => {
    const selectedFiles = event.target.files;
    let temp = { ...subCategory };
    let validateTemp = { ...validation };
    if (!selectedFiles) return;
    else {
      validateTemp.subCategoryImage = false;
      temp.subCategoryImage = URL.createObjectURL(selectedFiles?.[0]);
      temp.subCategoryImageReader = selectedFiles?.[0];
      setSubCategory(temp);
    }
    setValidation(validateTemp);
  };
  const handleSaveSubCategory = async () => {
    let temp = { ...subCategory };
    let validateTemp = { ...validation };
    // let length = temp.length - 1
    if (
      !temp.subCategoryName &&
      !temp.subCategoryImage &&
      !temp.primaryCategory
    ) {
      validateTemp.subCategoryName = true;
      validateTemp.subCategoryImage = true;
      validateTemp.primaryCategory = true;
    } else if (!temp.subCategoryName) {
      validateTemp.subCategoryName = true;
    } else if (!temp.subCategoryImage) {
      validateTemp.subCategoryImage = true;
    } else if (!temp.primaryCategory) {
      validateTemp.primaryCategory = true;
    } else {
      setLoading(true);
      let apiService = new APICallService(
        master.editSubCategory,
        categoryJSON.editSubCategory({ subCategory: subCategory }),
        { id: state.primaryCategories._id, subCategoryId: state._id },
        "",
        "",
        "",
        Categories,
        selectedWarehouse?.value || null,
      );
      let response = await apiService.callAPI();
      if (response) {
        success(masterToast.editSubCategory);
        navigate("/UProcure/master/categories");
        const {
          defaultCategory,
          subCategoryImageReader,
          ...restSubCategoryData
        } = subCategory;
        restSubCategoryData.primaryCategory =
          primaryCategory.find(
            (item: any) => item?._id === restSubCategoryData.primaryCategory,
          )?.title || "";
        initialSubCategory.primaryCategory =
          primaryCategory.find(
            (item: any) => item?._id === initialSubCategory.primaryCategory,
          )?.title || "";
        const data = Method.compareComplexObjects(
          initialSubCategory,
          restSubCategoryData,
        );

        const updatedData = {
          ...data,
          categoryType: "Sub Category",
          categoryName: subCategory.subCategoryName,
        };
      }
    }
    setValidation(validateTemp);
    setLoading(false);
  };
  return (
    <div className="p-5">
      <Row>
        <Col lg={12} className="mb-5">
          <h1 className="fs-22 fw-bolder">Edit sub category</h1>
        </Col>
        <Col lg={12}>
          <div className="border border-r10px bg-light position-relative mb-6 p-5">
            <Row>
              <Col lg={6} className="mb-6">
                <Row className="align-items-center">
                  <Col lg={4}>
                    <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3">
                      Category name
                    </label>
                  </Col>
                  <Col lg={8}>
                    <input
                      type="text"
                      className="form-control form-control-solid bg-white h-60px border form-control-lg text-dark fs-16 fw-600"
                      name="name"
                      placeholder="Type here…"
                      value={subCategory.subCategoryName}
                      onChange={(
                        e: React.ChangeEvent<HTMLInputElement>,
                      ): void => handleSubCategoryName(e.target.value, 0)}
                    />
                    <div className="fv-plugins-message-container">
                      <span className="text-danger fs-12 fw-bold">
                        {validation.subCategoryName
                          ? "Please enter category name"
                          : ""}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={6} className="mb-6">
                <Row className="align-items-center">
                  <Col lg={4}>
                    <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3">
                      Primary category
                    </label>
                  </Col>
                  <Col lg={8}>
                    <CustomSelect
                      isLoading={fetchLoader}
                      default={subCategory.defaultCategory}
                      options={
                        primaryCategory &&
                        primaryCategory.map((val: any) => ({
                          value: val.title,
                          name: val.title,
                          label: (
                            <>
                              <span className="symbol symbol-xl-40px symbol-35px border border-r10px me-2">
                                <img src={val.image} className="p-1" alt="" />
                              </span>
                              <span className="fs-16 fw-600 text-black ">
                                {val.title}
                              </span>
                            </>
                          ),
                          title: val.title,
                          _id: val._id,
                        }))
                      }
                      loadingMessage={"Fetching Data"}
                      isMulti={false}
                      onMenuScrollToBottom={onMenuScrollToBottom}
                      onMenuClose={() => {
                        onMenuClose();
                      }}
                      onMenuOpen={() => {
                        onMenuOpen();
                      }}
                      onInputChange={(newValue: any, { action }: any) => {
                        if (action === "input-change") {
                          handleInputChange(newValue);
                        }
                      }}
                      onChange={(
                        e: React.ChangeEvent<HTMLInputElement>,
                      ): void => handlePrimaryCategoryChange(e, 0)}
                    />
                    <div className="fv-plugins-message-container">
                      <span className="text-danger fs-12 fw-bold">
                        {validation.primaryCategory
                          ? "Please select primary category"
                          : ""}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col lg={2}>
                <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3 mt-lg-3">
                  Upload category image
                </label>
              </Col>
              <Col lg={10} className="d-flex">
                <div className="d-flex flex-column">
                  <div className="upload-btn-wrapper">
                    <div className="symbol symbol-160px symbol-md-170px">
                      <img
                        className="border bg-white"
                        src={
                          subCategory.subCategoryImage
                            ? subCategory.subCategoryImage
                            : UploadImage
                        }
                        alt=""
                      />
                    </div>
                    <input
                      className="w-100 h-100"
                      type="file"
                      name="myfile"
                      onChange={(
                        e: React.ChangeEvent<HTMLInputElement>,
                      ): void => handleImageChange(e, 0)}
                    />
                    <div className="fv-plugins-message-container">
                      <span className="text-danger fs-12 fw-bold">
                        {validation.subCategoryImage
                          ? "Please upload category image"
                          : ""}
                      </span>
                    </div>
                  </div>
                  <span className="text-gray text-italic">{`Image dimensions:-(700x700px)`}</span>
                </div>
                {subCategory.subCategoryImage && !loading ? (
                  <label
                    className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px responsive-closed"
                    data-kt-image-input-action="change"
                    title=""
                  >
                    <img
                      src={Close}
                      onClick={(): void => handleImageDiscard()}
                      className="responsive-closed-icon-closed"
                      alt=""
                      height={33}
                      width={33}
                    />
                  </label>
                ) : (
                  <></>
                )}
                <div className="d-flex flex-column ms-4 justify-content-end">
                  <span className="fs-14 fw-500 text-italic">
                    Note: Please upload a high resolution PNG image
                  </span>
                  <span className="fs-14 fw-500 text-italic">
                    (No background) for the category image.
                  </span>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end justify-content-md-start g-3">
        <Col xs="auto">
          <Button
            variant="danger"
            size="lg"
            className="uw-btn uw-btn-danger uw-btn-lg btn-active-danger"
            onClick={() => navigate("/UProcure/master/categories")}
          >
            Cancel
          </Button>
        </Col>
        <Col xs="auto">
          <Button className="uw-btn uw-btn-primary uw-btn-lg"
            variant="primary"
            size="lg"
            disabled={loading}
            onClick={handleSaveSubCategory}
          >
            {!loading && (
              <span className="indicator-label fs-16 fw-bold">
                Save changes
              </span>
            )}
            {loading && (
              <span
                className="indicator-progress fs-16 fw-bold"
                style={{ display: "block" }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default EditSubCategories;
